import type { FC } from 'react';
import styled from 'styled-components';
import type { SerializedThirdParty } from '@enmon/commons/lib/tools';
import { EmptyCell } from './table/cell';
import { Tooltip } from './tooltip/Tooltip';

interface StyledThirdPartyLogoProps {
  src: string;
  disabled?: boolean;
  width?: number;
  height?: number;
}

const StyledThirdPartyLogo = styled.div<StyledThirdPartyLogoProps>`
  background: url(${({ src }) => src}) no-repeat center;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  filter: ${({ disabled }) => (disabled ? 'grayscale(100%)' : 'none')};
  background-size: contain;
  width: ${({ width }) => (width ? `${width}px` : '4rem')};
  height: ${({ height }) => (height ? `${height}px` : '1.5rem')};
`;

const TransparentThirdPartyLogo = styled.div<Omit<StyledThirdPartyLogoProps, 'src'>>`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  filter: ${({ disabled }) => (disabled ? 'grayscale(100%)' : 'none')};
  background: transparent;
  width: ${({ width }) => (width ? `${width}px` : '4rem')};
  height: ${({ height }) => (height ? `${height}px` : '1.5rem')};
`;

export const ThirdPartyLogo: FC<{
  thirdParty: Pick<SerializedThirdParty, 'name' | 'company_number' | 'image_url'>;
  disabled?: boolean;
  width?: number;
  height?: number;
}> = ({ thirdParty, disabled, height, width }) => {
  if (!thirdParty) return <EmptyCell />;
  const { name, company_number: companyNumber, image_url: imageUrl } = thirdParty;

  return (
    <Tooltip
      title={
        <div className="text-center">
          {name}
          {companyNumber ? (
            <>
              <br />
              {companyNumber}
            </>
          ) : null}
        </div>
      }
    >
      {imageUrl ? (
        <StyledThirdPartyLogo height={height} width={width} src={imageUrl} disabled={disabled} />
      ) : (
        <TransparentThirdPartyLogo height={height} width={width} disabled={disabled} />
      )}
    </Tooltip>
  );
};
